import { render, staticRenderFns } from "./ShoppingCRMReports.vue?vue&type=template&id=6ad6637d&scoped=true"
import script from "./ShoppingCRMReports.vue?vue&type=script&lang=js"
export * from "./ShoppingCRMReports.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCRMReports.vue?vue&type=style&index=0&id=6ad6637d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6637d",
  null
  
)

export default component.exports